import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { sxDarkGreyBody } from "../../../../../assets/styles/CommonSxProps";
import AnexoButton from "../../../../../components/AnexoButton";
import { Anexo } from "../../../../../interfaces/entities/Reembolso/Anexo";
import { StepAnexoMotivoProps } from "../../../../../interfaces/props/Financeiro/Reembolso/StepAnexoMotivoProps";
import { retornaTermoReembolso } from "../../../../../services/Financeiro/ReembolsoService";
import { sxSubTitle } from "../../ValorReembolso/sxProps";
import { sxButton, sxLabel, sxMessageTextField } from "../sxProps";
import TermoFinalizacaoModal from "../TermoFinalizacaoModal";
import './styles.css';

const StepAnexoMotivo: React.FC<StepAnexoMotivoProps> = ({ handleBack, handleProceed, userRequestedToEditInfos, anexosAdicionados, motivo }) => {
  const [anexos, setAnexos] = useState<Array<Anexo>>([]);
  const [motivoAtendimentoParticular, setMotivoAtendimentoParticular] = useState<string>('');
  const [showTermoReembolso, setShowTermoReembolso] = useState<boolean>(false);
  const [termosFinalizacao, setTermosFinalizacao] = useState<string>('');

  const saveFiles = (Anexos: Array<Anexo>) => {
    setAnexos(Anexos);
  }

  useEffect(() => {
    verifyIfIsEditing();
    fetchTermoReembolso()
  }, [])

  const fetchTermoReembolso = async () => {
    const response = await retornaTermoReembolso();
    if (response?.status === 200) {
      setTermosFinalizacao(response.data.descricao);
    } else {
      console.error(response);
    }
  }

  const verifyIfIsEditing = () => {
    if (userRequestedToEditInfos && anexosAdicionados && motivo) {
      setAnexos(anexosAdicionados);
      setMotivoAtendimentoParticular(motivo)
    }
  }

  const handleShowTermosReembolso = () => {
    setShowTermoReembolso(show => !show);
  }

  return (
    <div className="feature-container">
      <Box display={'flex'} flexDirection={'column'} gap={'15px'}>
        <Typography component="h2" sx={sxSubTitle}>Motivo do atendimento particular</Typography>
        <div className='textfield-input-area'>
          <Typography sx={sxLabel}>Mensagem</Typography>
          <label htmlFor="outlined-textarea" aria-label="Mensagem" />
          <TextField
            id="outlined-textarea"
            type='text'
            value={motivoAtendimentoParticular}
            onChange={(e) => { setMotivoAtendimentoParticular(e.target.value); }}
            placeholder='Informe o motivo do atendimento'
            multiline
            inputProps={{ maxLength: 500 }}
            sx={sxMessageTextField}
          />
        </div>
        <div>
          <Typography sx={sxDarkGreyBody}>Anexe exames ou documentos na solicitação:</Typography>
          <div>
            <div className="anexo-motivo-file-button">
              <AnexoButton salvarAnexos={saveFiles} anexos={anexos} />
            </div>
            <div className="anexo-motivo-file-guide">
              <Typography sx={sxDarkGreyBody}>
                Você pode anexar arquivos .pdf, .jpg, .doc e .png de até 4mb, sendo de notas fiscais/recibos, pedidos médicos, relatórios médicos, entre outros.
              </Typography>
            </div>
            <div className="anexo-button">
              <Button
                variant="contained"
                type='submit'
                sx={sxButton}
                disabled={anexos.length === 0 || !motivoAtendimentoParticular}
                onClick={handleShowTermosReembolso}
                fullWidth>
                Continuar
              </Button>
            </div>
            <button className="back-button margin-top-30" onClick={() => handleBack()} aria-label="Voltar para dados do prestador">
              <FontAwesomeIcon icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
            </button>
          </div>
        </div>
      </Box>
      <TermoFinalizacaoModal open={showTermoReembolso} closeTermsOfUse={handleShowTermosReembolso}
        handleTermsOfUse={() => handleProceed(anexos, motivoAtendimentoParticular)} textoTermos={termosFinalizacao}
      />
    </div>
  )
}

export default StepAnexoMotivo;